import { IconSize, Icons } from '@pdcfrontendui/components';
import { TeamViewMode, getSiteRoutes, useTeamRouteParams } from '../routes';
import { Store, connect } from '../rootReducer';
import { toggleCalendar, toggleSearchBar } from '../appActions';

import Header from '@pdcfrontendui/components/Header';
import { ThunkDispatch } from '../types';
import ids from '../testing/ids';
import { useNavigate } from 'react-router-dom';
import { currentLanguage } from '../currentLanguage';
import {
  ShiftDraft,
  ShiftDraftType,
} from '../ListView/CreateShift/EditedShift';
import { setShiftDraft } from '../ShiftView/ShiftViewActions';
import { EDITED_SHIFT_ID } from '../constants';

type Props = {
  title: string;
  loadDaysFromDate: (date: Date, days: number) => void;
};

type StateFromProps = {
  activeDate: Date;
  shouldShowCalendar: boolean;
  shouldShowSearchBar: boolean;
  teamId: string;
  shiftDraft: ShiftDraft | null;
  activeScope: number;
};

type DispatchFromProps = {
  toggleCalendar: () => void;
  toggleSearchBar: () => void;
  setShiftDraft: (shift: ShiftDraft | null) => void;
};

const mapStateToProps = (store: Store): StateFromProps => ({
  activeDate: store.appReducer.activeDate,
  shouldShowCalendar: store.appReducer.shouldShowCalendar,
  shouldShowSearchBar: store.appReducer.shouldShowSearchBar,
  teamId: store.listViewReducer.currentTeam,
  shiftDraft: store.shiftViewReducer.shiftDraft,
  activeScope: store.appReducer.settings.activeScope,
});

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchFromProps => ({
  toggleCalendar: () => {
    dispatch(toggleCalendar());
  },
  toggleSearchBar: () => {
    dispatch(toggleSearchBar());
  },
  setShiftDraft: (shift) => {
    dispatch(setShiftDraft(shift));
  },
});

const TopHeader = ({
  title,
  teamId,
  activeDate,
  shouldShowSearchBar,
  shouldShowCalendar,
  loadDaysFromDate,
  toggleCalendar,
  toggleSearchBar,
  shiftDraft,
  setShiftDraft,
  activeScope,
}: Props & StateFromProps & DispatchFromProps) => {
  const navigate = useNavigate();
  const params = useTeamRouteParams();
  const isEditingShift =
    (params.shiftId === EDITED_SHIFT_ID ||
      params.mode === TeamViewMode.CreateOrEdit) &&
    shiftDraft !== null;
  return (
    <Header centerize>
      <Header.Left>
        <Icons.Plus
          ariaLabel={currentLanguage.CreateNewShift}
          aria-disabled={isEditingShift}
          style={{ opacity: isEditingShift ? 0.5 : 1 }}
          onClick={() => {
            if (!isEditingShift) {
              setShiftDraft({
                type: ShiftDraftType.NewlyCreated,
              });
              navigate(
                getSiteRoutes().team(teamId, {
                  ...params,
                  mode: TeamViewMode.CreateOrEdit,
                })
              );
            }
          }}
        />
      </Header.Left>
      <Header.Title bold>{title}</Header.Title>
      {!shouldShowSearchBar && teamId !== '' && (
        <Header.Right>
          <Icons.Search
            id={ids.Router.SearchButton}
            onClick={() => {
              if (shouldShowCalendar) {
                loadDaysFromDate(activeDate, activeScope);
                toggleCalendar();
              }
              toggleSearchBar();
            }}
            size={IconSize.XSmall}
          />
        </Header.Right>
      )}
    </Header>
  );
};

export default connect<StateFromProps, DispatchFromProps, Props>(
  mapStateToProps,
  mapDispatchToProps
)(TopHeader);
